import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationSpecification = ({ location, equipment, onLocationChange, onEquipmentChange }) => {
  const locations = [
    'Plant 1 - Main Facility',
    'Plant 2 - North Wing',
    'Plant 3 - South Wing',
    'Warehouse 1',
    'Loading Dock',
    'Assembly Line A',
    'Storage Area B'
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Location Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Location <span className="text-red-500">*</span>
          </label>
          <select
            value={location}
            onChange={(e) => onLocationChange(e?.target?.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            required
          >
            <option value="">Select location...</option>
            {locations?.map((loc) => (
              <option key={loc} value={loc}>{loc}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Equipment Tag (Optional)
          </label>
          <div className="relative">
            <input
              type="text"
              value={equipment}
              onChange={(e) => onEquipmentChange(e?.target?.value)}
              placeholder="Enter equipment ID or scan tag"
              className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary pr-10"
            />
            <button
              type="button"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              <Icon name="Scan" size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSpecification;